import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { GetOrderDetails } from "../../../../services";

export default class PreorderBatchLive extends Component {
  state = { batchLogs: [], isRunning: false };

  // Only manual trigger, no auto-run
  componentDidMount() {
    // this.runBatchProcessing(); // ← optional: remove this if you don't want it to run once on load
  }

  runBatchProcessing = async () => {
    this.setState({ isRunning: true });
    const res = await GetOrderDetails.runPreorderBatch();
    if (res.success && res.batchLog) {
      this.setState((prev) => ({
        batchLogs: [...prev.batchLogs, res.batchLog],
        isRunning: false,
      }));
    } else {
      this.setState({ isRunning: false });
    }
  };

  renderLogTable() {
    const { batchLogs } = this.state;
    if (batchLogs.length === 0) return <p>No batch logs yet.</p>;

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Batch #</th>
            <th>Timestamp</th>
            <th>Total</th>
            <th>Inserted</th>
            <th>Deleted</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {batchLogs.map((batch, index) => (
            <tr key={index}>
              <td>{batch.batchNumber}</td>
              <td>{new Date(batch.timestamp).toLocaleString()}</td>
              <td>{batch.totalProcessed}</td>
              <td>{batch.inserted.length}</td>
              <td>{batch.deleted.length}</td>
              <td>
                <details>
                  <summary>Show</summary>
                  <pre style={{ whiteSpace: "pre-wrap" }}>
                    {JSON.stringify(batch.processed, null, 2)}
                  </pre>
                </details>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className="container mt-4">
        <h3>Live Preorder Batch Logs</h3>
        <Button
          variant="contained"
          color="primary"
          onClick={this.runBatchProcessing}
          disabled={this.state.isRunning}
        >
          {this.state.isRunning ? "Processing..." : "Run Batch Now"}
        </Button>
        <div className="mt-4">{this.renderLogTable()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/cron/view/index.js